import { Tc, PagingResultsViewModel, FilterSearchingBaseViewModel, EnumSiNoTodos } from '../../../core/_infrastructure/types/common';

export class GrupoItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: GrupoViewModel[];
}

export class GrupoViewModel {
    constructor() {}

    public Id: number;
    public Descripcion: string = '';
    public EmbalajeObligatorio: boolean = false;
}

export class FilterSearchingGrupoViewModel extends FilterSearchingBaseViewModel {
    public EmbalajeObligatorio: number = EnumSiNoTodos.TODOS;
}

export class FormaItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: FormaViewModel[];
}

export class FormaViewModel {
    constructor() {}

    public Id: number;
    public IdGrupo: number = 0;
    public Descripcion: string = '';
    public DescripcionIngles: string = '';
    public TracesProductCode: string = '';
    public EphytoReinoUnido: boolean;
    public EspecieSinEppo: boolean;

    // (emarti69) variable creada para saber si el usuario quiere modificar el valor EphytoReinoUnido para todas las especies asociadas a la forma que está editando, o tan solo modificar el valor para la forma
    public ModifyAllSpecies: boolean;
}

export class SubFormaItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: SubFormaViewModel[];
}

export class SubFormaViewModel {
    constructor() {}

    public Id: number;
    public IdForma: number;
    public Descripcion: string = '';
}
